import React from 'react';
import { ShieldCheck, CreditCard, Lock } from 'lucide-react';
export function SecuritySection() {
  return <section className="py-12 bg-slate-900 border-b border-slate-800 px-4" data-id="element-129">
      <div className="max-w-4xl mx-auto text-center" data-id="element-130">
        <div className="flex flex-wrap justify-center gap-8 md:gap-16 mb-8" data-id="element-131">
          <div className="flex items-center gap-3 text-slate-300 font-medium" data-id="element-132">
            <Lock className="w-6 h-6 text-green-500" data-id="element-133" />
            <span data-id="element-134">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-3 text-slate-300 font-medium" data-id="element-135">
            <CreditCard className="w-6 h-6 text-blue-500" data-id="element-136" />
            <span data-id="element-137">Medios de pago disponibles</span>
          </div>
          <div className="flex items-center gap-3 text-slate-300 font-medium" data-id="element-138">
            <ShieldCheck className="w-6 h-6 text-indigo-500" data-id="element-139" />
            <span data-id="element-140">Garantía de 7 días</span>
          </div>
        </div>

        <div className="bg-slate-800 rounded-2xl p-6 border border-slate-700 inline-block max-w-2xl" data-id="element-141">
          <p className="text-slate-400" data-id="element-142">
            <strong className="text-white" data-id="element-143">Garantía incondicional:</strong> Si
            el curso no es para vos, pedís el reembolso y listo, sin preguntas.
            Tienes 7 días completos para probarlo sin riesgo.
          </p>
        </div>
      </div>
    </section>;
}